import React from "react";
import { useTaskDialog } from "../context/task-dialog";
import NewTask from "../pages/tasks/new-task";
import { useQueryClient } from "@tanstack/react-query";
import { API_URL } from "../utilities";
import { useAuth } from "../context/auth";

const GlobalTaskDialog: React.FC = () => {
  const { isOpen, closeTaskDialog } = useTaskDialog();
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const handleClose = () => {
    closeTaskDialog();
  };

  const handleRefetch = async () => {
    if (user?.token) {
      try {
        // Invalidate and refetch the tasks query
        queryClient.invalidateQueries({ queryKey: ["TasksData"] });
      } catch (error) {
        console.error("Error refetching tasks:", error);
      }
    }
  };

  return (
    <NewTask open={isOpen} handleClose={handleClose} refetch={handleRefetch} />
  );
};

export default GlobalTaskDialog;
